export function createOrMessage(pieces: string[]): string {
  if (pieces.length === 1) {
    return pieces[0];
  } if (pieces.length === 2) {
    return `${pieces[0]} or ${pieces[1]}`;
  } if (pieces.length > 2) {
    const piecesWithComma = pieces
      .slice(0, pieces.length - 2)
      .map(piece => `${piece}, `);

    return `${piecesWithComma}${pieces[pieces.length - 2]} or ${pieces[pieces.length - 1]}`;
  }

  return '';
}
